<template>
  <div>
    <v-data-table
      :items="items"
      hide-actions
      :headers="headers"
      :loading="loader"
      :headers-length="6"
    >
      <template slot="headers">
        <tr>
          <template v-if="desktopOnly">
            <th
              v-for="header in headers"
              :key="header.text"
              class="text-xs-left"
            >
              {{ header.text }}
              <BaseIcon
                v-if="header.icon"
                width="16px"
                height="13px"
              >
                <component :is="header.icon" />
              </BaseIcon>
            </th>
          </template>
          <template v-for="header in headers">
            <th
              v-if="!header.desktopOnly && !desktopOnly"
              :key="header.text"
              class="text-xs-left"
            >
              {{ header.text }}
              <BaseIcon
                v-if="header.icon"
                width="16px"
                height="13px"
              >
                <component :is="header.icon" />
              </BaseIcon>
            </th>
          </template>
        </tr>
      </template>
      <template
        slot="items"
        slot-scope="props"
      >
        <tr>
          <td v-if="desktopOnly">
            {{ props.item.family_to_accept_id }}
          </td>
          <td>
            {{ fullName(props.item.first_name, props.item.last_name) }}
            <div v-if="!desktopOnly">
              <div>
                {{ address(props.item.street, props.item.building_number, props.item.flat_number) }}
              </div>
              <div>
                {{ city(props.item.postal_code, props.item.city) }}
              </div>
            </div>
          </td>
          <td v-if="desktopOnly">
            <div>
              {{ address(props.item.street, props.item.building_number, props.item.flat_number) }}
            </div>
            <div>
              {{ city(props.item.postal_code, props.item.city) }}
            </div>
          </td>
          <td class="pl-1">
            <FamilyStatus
              :mobile="!desktopOnly"
              :status="props.item.status"
            />
          </td>
          <td>
            <div>
              <a @click="doAction($event, props.item)">
                {{ $t('alikes_table.action_menu.1') }}
              </a>
            </div>
          </td>
        </tr>
      </template>
      <template slot="no-data">
        <tr>
          <td colspan="6">
            <p
              v-show="!loader"
              class="text-xs-center pt-3"
            >
              {{ $t('message.error_families_list_empty') }}
            </p>
          </td>
        </tr>
      </template>
    </v-data-table>
    <FamilySimilar
      v-model="similarValue"
      :loading="similarLoading"
      @close="similarValue = false"
      @forDecision="similarValue = false"
      @overwriteFamily="overwriteFamily"
      @addNewFamily="addFamily"
    />
    <AppModal
      :visible="confirmationDialog"
      persistent
      @close="finishActions()"
    >
      <template #content>
        <v-layout align-center>
          <v-icon
            color="green"
            pr-5
            mr-5
            large
          >
            check_circle_outline
          </v-icon>
          <h2 class="text-xs-left f-16 sz_grafit--text ma-0 mt-1 ml-2 font-weight-regular">
            {{ confirmationDialogText }}
          </h2>
        </v-layout>
      </template>
      <template #actions>
        <v-layout justify-end>
          <v-btn
            color="sz_violet"
            @click="finishActions()"
          >
            {{ $t('buttons.ok') }}
          </v-btn>
        </v-layout>
      </template>
    </AppModal>
  </div>
</template>

<script>
import FamilySimilar from '@/components/widgets/addFamily/FamilySimilar';
import FamilyStatus from '@/components/widgets/dataTable/FamilyStatus';
import BaseIcon from '@/icons/BaseIcon';
import ChangeIcon from '@/icons/ChangeIcon';
import SortIcon from '@/icons/SortIcon';
import AppModal from '@/components/widgets/AppModal.vue';

import filters from '@/constants/filters';

export default {
    name: 'ToBeIdentifiedAlikesFamiliesTable',
    components: {
        BaseIcon,
        ChangeIcon,
        SortIcon,
        FamilyStatus,
        FamilySimilar,
        AppModal
    },
    filters: {
        ...filters
    },
    props: ['items', 'isLoading'],
    data () {
        return {
            headers: [
                {
                    text: this.$t('label.id'),
                    desktopOnly: true
                },
                {
                    text: this.$t('label.family'),
                    desktopOnly: false
                },
                {
                    text: this.$t('label.address'),
                    desktopOnly: true
                },
                {
                    text: this.$t('label.status'),
                    desktopOnly: false
                },
                {
                    text: this.$t('label.action'),
                    desktopOnly: false
                }
            ],
            drafts: [],
            family: {},
            familyID: null,
            similarValue: false,
            loader: false,
            similarLoading: false,
            confirmationDialog: false,
            confirmationDialogText: ''
        };
    },
    computed: {
        desktopOnly () {
            return this.$vuetify.breakpoint.smAndUp;
        },
        similarityParameters () {
            return this.$store.getters['familyData/getSimilarityParameters'];
        }
    },
    watch: {
        isLoading: {
            handler (val) {
                this.loader = val;
            },
            immediate: true
        }
    },
    methods: {
        fullName (name, surname) {
            const _name = name || '';
            return `${_name} ${surname}`;
        },
        address (street, building, flat) {
            const _street = street ? street + ', ' : '';
            const _flat = flat ? '/' + flat : '';
            return _street + building + _flat;
        },
        city (code, city) {
            return this.$options.filters.postalCode(code) + ', ' + city;
        },
        doAction ($event, item) {
            this.loader = true;
            this.$store.commit('familyData/clearFormData');
            this.familyID = item.family_to_accept_id;
            this.$store.commit('familyData/assignFamilyData', { ...item });
            this.$store.commit('familyData/setLocation', {
                node: { id: item.wio_struct_location_id, description: '' },
                native: true
            });
            this.$store
                .dispatch('familyData/checkSimilarFamilies')
                .then(() => {
                    this.similarValue = true;
                })
                .finally(() => {
                    this.loader = false;
                });
        },
        finishActions () {
            this.confirmationDialog = false;
            this.$store.commit('familyData/clearFormData');
            setTimeout(() => {
                this.$emit('reload');
            }, 600);
        },
        removeFamilyToDecide () {
            return this.$store.dispatch('familiesToAccept/removeFamilyToAccept', this.familyID);
        },
        overwriteNextActions () {
            this.similarValue = false;
            this.confirmationDialog = true;
            this.confirmationDialogText = this.$t('message.overwrite_family_success');
        },
        overwriteFamily () {
            this.similarLoading = true;
            if (this.similarityParameters.chosenFamily !== -1) {
                this.removeFamilyToDecide()
                    .then(() => {
                        this.overwriteNextActions();
                    })
                    .finally(() => {
                        this.similarLoading = false;
                    });
            } else {
                this.$store
                    .dispatch('familyData/overwriteFamilyData')
                    .then(() => {
                        this.removeFamilyToDecide();
                    })
                    .then(() => {
                        this.overwriteNextActions();
                    })
                    .finally(() => {
                        this.similarLoading = false;
                    });
            }
        },
        addFamily () {
            this.similarLoading = true;
            return this.$store
                .dispatch('familyData/convertToFamily', this.familyID)
                .then(() => {
                    this.similarValue = false;
                    this.confirmationDialog = true;
                    this.confirmationDialogText = this.$t('message.add_family_success');
                })
                .finally(() => {
                    this.similarLoading = false;
                });
        }
    }
};
</script>

<style scoped></style>
